import { render, staticRenderFns } from "./ThreadHeader.vue?vue&type=template&id=647cc280&scoped=true"
import script from "./ThreadHeader.vue?vue&type=script&lang=js"
export * from "./ThreadHeader.vue?vue&type=script&lang=js"
import style0 from "./ThreadHeader.vue?vue&type=style&index=0&id=647cc280&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647cc280",
  null
  
)

export default component.exports